<template>
    <o-modal @showModal="showModal">
        <template v-slot:header>
            {{ item.title }}
        </template>
        <template v-slot:body>
            <o-form autocomplete="off">
                <div v-if="errors.length">
                    <div class="alert alert-danger">
                        <p>
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                            </ul>
                        </p>
                    </div>
                </div>
                <o-form-group title="Discount Type" name="discountType" class="text-start mb-2">
                    <span class="text-danger">*</span>
                    <select v-model="item.discount_type" class="form-select" @change="calculateSubtotal">
                        <option value="amount">Amount</option>
                        <option value="percentage">Percentage</option>
                    </select>
                </o-form-group>
                <o-form-group title="Discount Value" name="discountValue" class="text-start mb-2">
                    <span class="text-danger">*</span>
                    <o-input-text name="discountValue" v-model="discountValue" type="number" :required="true"/>
                </o-form-group>
                <o-form-group title="Subtotal" name="subtotal" class="text-start mb-2">
                    <o-input-text name="subtotal" v-model="item.subtotal" type="text" mask="idr" :required="true" :readonly="true"/>
                </o-form-group>
                
                <div class="d-flex d-inline-block">
                    <div class="me-2">
                        <o-button @click="saveDetail" :variant="'primary'" :white="'white'" type="submit">Save</o-button>
                    </div>
                    <div class="ms-1">
                        <o-button @click="clearFields" :variant="'danger'" :white="'white'">Clear Discount</o-button>
                    </div>
                    <div class="ms-1">
                        <o-button @click="closeModal" :variant="'outline-secondary'">Close</o-button>
                    </div>
                </div>
            </o-form>
        </template>
    </o-modal>
</template>


<script>
import { OModal,OForm, OFormGroup, OInputText, OButton } from '@/components/OmnihControl';

export default {
    name: 'AddDiscount',
    components: {
        OModal,
        OForm,
        OFormGroup,
        OInputText,
        OButton
    },
    props: [
        'editedItem',
        'validationdetail',
    ],
    data: function() {
        return{
            item: {
                name: '',
                subtotal: '',
                total: '',
                total_first: '',
                discount_type: 'amount',
                discount_value: 0,
                title: 'Create Discount'
            },
            discountValue: 0,
            validationDetail: this.validationdetail,
            isModalVisible: false,
            errors: [],
            validation: [],
            page: {
                isLoading: true
            }
        }
    },
    mounted: function() {
        if(Object.keys(this.editedItem).length !== 0 && Object.keys(this.editedItem).length !== 2){ 
            this.item = {...this.editedItem}
            this.item.total_first = this.item.total
            this.item.total = this.item.subtotal
            this.item.subtotal = this.priceFormat(this.item.subtotal)
            this.item.discount_value = this.editedItem.discount_value;
            this.item.discount_type = this.editedItem.discount_type;
            this.discountValue = this.editedItem.discount_value;
            this.item.title = this.editedItem.title == 'Create Transaction' ? 'Create Discount' : 'Edit Discount';
        }

        this.page.isLoading = false;
    },
    methods: {
        showModal(){
            this.transaction.isModalVisible = true
        },
        closeModal(e){
            e.preventDefault()
            this.$emit('parentCloseModal')
        },
        saveDetail(){
            this.errors = [];

            if ((!this.item.discount_value || this.item.discount_value <= 0) && this.item.title == 'Create Discount' ) {
                this.errors.push('Valid discount value is required.');
            }

            if (this.item.subtotal <= 0 && this.item.title == 'Create Discount') {
                this.errors.push('Subtotal cannot be negative. Adjust your discount.');
            }

            if (this.item.title === 'Edit Discount') {
                if (this.item.discount_type && (!this.item.discount_value || this.item.discount_value <= 0)) {
                    this.errors.push('When discount type is set, discount value must be provided and cannot be zero.');
                }
            }

            if (this.errors.length === 0) {
                const numericSubtotal = parseInt(this.item.subtotal.replace(/\./g, '')) || 0;
                const itemToEmit = {
                    ...this.item,
                    subtotal: numericSubtotal
                };
                this.$emit('parentAddItem', itemToEmit);
            }
        },
        clearFields() {
            this.item.discount_type = ''; 
            this.discountValue = '';
            this.item.discount_value = ''; 
            this.errors = []; 

            const validSubtotal = this.item.total_first || this.item.total || 0;
            this.item.subtotal = this.priceFormat(validSubtotal);
        },
        calculateSubtotal() {
            const subtotalValue = parseFloat(this.item.total) || 0; 
            const discountValue = parseFloat(this.discountValue) || 0;
            if (this.item.discount_type === 'amount') {
                this.item.subtotal = subtotalValue - discountValue;
            } else if (this.item.discount_type === 'percentage') {
                this.item.subtotal = subtotalValue * (1 - (discountValue / 100));
            }
            
            if (this.item.subtotal < 0) {
                this.item.subtotal = 0;
            }

            this.item.subtotal = this.priceFormat(this.item.subtotal)
        },
        priceFormat(subtotal) {
            const intValue = Math.floor(subtotal);
            const formatted = intValue.toString().replace(/[^0-9]/g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
            return formatted;
        },
        handleMembersLoaded() {
            this.page.isLoading = false;
        }
    },
    watch: {
        discountValue: function (val) {
            if (val !== this.item.discount_value) {
                this.item.discount_value = val; // Update the discount value
                this.calculateSubtotal(); // Recalculate subtotal only if the value has changed
            }else if(val == this.item.discount_value) {
                this.item.discount_value = val; // Update the discount value
            }
        }
    }
}
</script>